import React from "react";
// import { Box, Modal, Typography } from "@mui/material";
import Modal from "react-bootstrap/Modal";
import CloseIcon from "@mui/icons-material/Close";
import "../index.css";
import { Orders } from "../../../common/interfaces";

// Función auxiliar para formatear cantidades
const formatQuantity = (quantity: string | number): string => {
  const num = Number(quantity);
  return Number.isInteger(num) ? num.toString() : num.toFixed(2);
};

interface DetailsModalProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  data?: Orders;
}
function DetailsModal({ open, setOpen, data }: DetailsModalProps) {
  const hideModal = () => {
    setOpen(false);
    // setDisplay(false);
    // console.log("hide");
  };
  const handleClose = () => setOpen(false);

  return (
    <Modal
      show={open}
      fullscreen={"lg"}
      onHide={() => {
        hideModal();
      }}
    >
        {
          data && (
            <>
              <Modal.Header closeButton>
                  <div className="fw-bold">Orden # {data.id}</div>
              </Modal.Header>
              <Modal.Body>
                <div className="ms-2 me-auto">
                  <strong>Cliente: </strong> {data.cliente.nombre} <br />
                  <strong>Fecha: </strong> {data.fecha} <br />
                  <strong>Total: </strong> {data.total} <br />
                  <strong>Estado: </strong> {data.status} <br />
                  {
                    data.schedule && (
                      <>
                        <strong>Fecha de Agenda: </strong> {data.schedule} <br />
                      </>
                    )
                  }
                  <table className="table">
                    <thead>
                      <tr>
                        <th style={{ width: "60%" }}>Producto</th>
                        <th style={{ width: "20%", textAlign: "center" }}>Cantidad</th>
                        <th style={{ width: "20%", textAlign: "right" }}>Precio</th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.detalles.map((detalle) => (
                        <tr key={detalle.id}>
                          <td style={{ verticalAlign: "middle", wordWrap: "break-word", hyphens: "auto" }}>
                            {detalle.producto.name}
                            {/* Lo que eligio el cliente (sabor, refresco, coccion...). Sin esto,
                                el detalle de la orden no dice con que se prepara el platillo. */}
                            {detalle.options && (
                              <div style={{ fontSize: "13px", color: "#6c757d", marginTop: "2px" }}>
                                {detalle.options.split(",").map((option, i) => (
                                  option.trim() !== "" && <div key={i}>- {option.trim()}</div>
                                ))}
                              </div>
                            )}
                          </td>
                          <td style={{ textAlign: "center", verticalAlign: "middle" }}>
                            <span className="badge bg-primary rounded-pill" style={{ fontSize: "13px", minWidth: "80px", display: "inline-block" }}>
                              {formatQuantity(detalle.cantidad)} {detalle.producto.unit || ''}
                            </span>
                          </td>
                          <td style={{ textAlign: "right", verticalAlign: "middle" }}>${detalle.precio}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {/* {JSON.stringify(data.detalles)} */}
                </div>
              </Modal.Body>
            </>
          )
        }
    </Modal>
  );
}

export default DetailsModal;
